import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { isMgbwWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { TYPOGRAPHY } from "@tSurya/theme/design";

import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = mergeToNew(dateRangeStyles.datePickersWrapper, {
    css: css`
        display: flex;
        gap: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-direction: column;
                `,
                null,
                null,
                null,
                null,
            ])}
        > div {
            width: 42%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 50%;
                    `,
                    css`
                        width: 50%;
                    `,
                    css`
                        width: 50%;
                    `,
                    css``,
                ])}
        }
        div[class^="FormInputWrapper"] .react-datetime-picker {
            height: 40px;
        }
        div[class^="FormInputWrapper"] .react-datetime-picker__clear-button svg {
                margin-bottom: -4px;
        }
    `,
});

dateRangeStyles.fromDate = {
    cssOverrides: {
        formField: css`
            > label {
                font-size: ${TYPOGRAPHY.size.smaller} !important;
            }
            > label + div[class^="FormInputWrapper"] {
                margin-top: 3px !important;
            }
        `,

        datePicker: css`
            div[class^="react-datetime-picker__inputGroup"] {
                display: flex;
                align-items: center;
                ${isMgbwWebsite()
                    ? css`
                          span[class^="react-datetime-picker__inputGroup__leadingZero"] {
                              margin: 0 !important;
                          }
                      `
                    : null}
            }
        `,
    },
};
dateRangeStyles.toDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-left: 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
            > label + div[class^="FormInputWrapper"] {
                margin-top: 3px !important;
                @media (min-width: 1440px) {
                    margin-top: 4px !important;
                }
            }

            div[class^="react-datetime-picker__inputGroup"] {
                display: flex;
                align-items: center;
                ${isMgbwWebsite()
                    ? css`
                          span[class^="react-datetime-picker__inputGroup__leadingZero"] {
                              margin: 0 !important;
                          }
                      `
                    : null}
            }
        `,
        formInputWrapper: css`
            div[class^="react-calendar"] {
                left: unset !important;
                right: 0px !important;
            }
        `,
        datePicker: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        position: relative;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}

            div[class^="react-datetime-picker__inputGroup"] {
                display: flex;
                align-items: center;
                ${isMgbwWebsite()
                    ? css`
                          span[class^="react-datetime-picker__inputGroup__leadingZero"] {
                              margin: 0 !important;
                          }
                      `
                    : null}
            }
        `,
    },
    labelProps: {
        color: "common.background",
    },
};
